
import {logger, createLogger, destroyLogger } from './utils/logger.js';
import MainPlayer from './core/mainplayer.js';
import EventEmitter from 'eventemitter3';
import { STREAM_BUSI_TYPE, ContentFitType, TALK_BUSI_TYPE } from './constant/index.js';
import { supportOffScreenCanvas, supportMSE, supportMSEForWorker, GenRandomString } from './utils/index.js';

const DEFAULT_PLAYER_OPTIONS = {

    logEnable:false,
    logLevel:'info',

    container:'',           //外部容器，用于放置渲染画面

    

    playMode:'live',        //live 或者 playback

    useWebRtcRender:false, // 是否是webrtc，采用独立的渲染方式，不受renderMode控制

    renderMode: 'canvas',   // canvas, mse
    useOffScreenCanvasRender:false, // 线程里渲染canvas
    canvasRenderMode:'normal', // normal:正常
    canvasRenderAccelerationMode:'webgl',  //webgl
    useWorkerForMSE:true, //线程里渲染mse
    useMSEAudioWhenMSERenderMode:true, //当使用MSE 渲染模式时，声音是否使用MSE播放
    audioEngine:"worklet", //script, worklet,

    x:0,
    y:0,
    width:480,
    height:480,

    renderOptions: { 

        contentFit: ContentFitType.contain, //内容填充模式, 默认是 contain
        brightness: 1.0, //亮度，默认是1.0, 范围  [0, 2.55]
        saturate:1.0, //饱和度，默认是1.0, 范围  [0, 2.55]
        contrast:1.0, //对比度，默认是1.0, 范围  [0, 2.55]
        huerotate:0 //色度偏移（角度），默认是 0度, 范围  [0, 180]

    },

    videoBuffer:500, //缓冲时长 ms
    videoBufferDelay:500, //播放允许的延迟 ms

    retryCnt:-1,       //拉流失败重试次数
    retryDelay: 5,     //重试时延 5000

    decoderMode:"normal",

    streamBusiType:STREAM_BUSI_TYPE.flv,   //'flv', 'hmLiveStream'
    url:'',//flv播放地址

    userToken:'', // hmLiveStream 的参数
    peerId:'', 
    playUrl:'', 
    resourceId:'', 
    encType:0,
    encKey:'', 
    encLoad:'', 
    camId:0, 
    streamId:0, 
    audioFlag:-1,
    channelNum:0,

    webrtcUrl:''
}

class HMWebPlayer extends EventEmitter{

    options = undefined;
    mainplayer = undefined;

    tag = 'HMWebPlayer'

    constructor(options) {
        super();

        let renderOptions = Object.assign({}, DEFAULT_PLAYER_OPTIONS.renderOptions, options.renderOptions);
        this.options = Object.assign({}, DEFAULT_PLAYER_OPTIONS, options);
        this.options.renderOptions = renderOptions 

        if (!this.options.playerId) {

            this.options.playerId = GenRandomString(6)
        }


        createLogger(this, this.options.logEnable, this.options.logLevel)

        // 支持dom id 或者 dom 元素
        if (typeof this.options.container === 'string') {
            logger.info(this.tag, `container is dom id`)
            this.container = document.getElementById(this.options.container);
          } else {
            logger.info(this.tag, `container is dom element`)
            this.container = this.options.container
          }

        this.correctAbility()

        logger.info(this.tag, `new player success, options: ${JSON.stringify(this.options)}`);

    }
    
    
    correctAbility () {

        //根据浏览器能力矫正一些属性 useOffScreenCanvasRender, useWorkerForMSE, audioEngine
        
        if (this.options.useOffScreenCanvasRender) {

            this.options.useOffScreenCanvasRender = supportOffScreenCanvas()
        }

        if (this.options.renderMode == 'mse') {

            if (!supportMSE()) {

                this.options.renderMode = 'canvas'
            }
        }

        if (this.options.useWorkerForMSE) {

            this.options.useWorkerForMSE = supportMSEForWorker()
        }

        if (this.options.renderMode != 'mse') {

            this.options.useMSEAudioWhenMSERenderMode = false
        }

        if (this.options.audioEngine == 'worklet') {

            if (window.location.protocol != 'https:' && window.location.hostname != '127.0.0.1' && window.location.hostname != 'localhost') {

                this.options.audioEngine = 'script'
            }
        }

    }

    
    startFlv(url) {

        this.options.useWebRtcRender = false
        this.options.streamBusiType = STREAM_BUSI_TYPE.flv
        this.options.url = url
        this.start()
    }

    startHMLiveStream(userToken, peerId, playUrl, resourceId, encType, encKey, encLoad, camId, streamId, audioFlag, channelNum) {

        this.options.useWebRtcRender = false
        this.options.streamBusiType = STREAM_BUSI_TYPE.hmLiveStream
        this.options.userToken = userToken
        this.options.peerId = peerId
        this.options.playUrl = playUrl
        this.options.resourceId = resourceId
        this.options.encType = encType
        this.options.encKey = encKey
        this.options.encLoad = encLoad
        this.options.camId = camId
        this.options.streamId = streamId
        this.options.audioFlag = audioFlag
        this.options.channelNum = channelNum
        

        this.start()
    }

    startHMTFCardStream(userToken, peerId, playUrl, resourceId, encType, encKey, encLoad, playTime) {

        this.options.useWebRtcRender = false
        this.options.streamBusiType = STREAM_BUSI_TYPE.hmTFCardStream
        this.options.userToken = userToken
        this.options.peerId = peerId
        this.options.playUrl = playUrl
        this.options.resourceId = resourceId
        this.options.encType = encType
        this.options.encKey = encKey
        this.options.encLoad = encLoad
        this.options.playTime = playTime

        this.start()
    }

    startHMWebRtc(webrtcUrl) {

        this.options.useWebRtcRender = true
        this.options.streamBusiType = STREAM_BUSI_TYPE.hmWebRtc
        this.options.webrtcUrl = webrtcUrl
        this.start()
    }
    startHMCloudStream(peerId, camId, playTime, videoList) {

        this.options.streamBusiType = STREAM_BUSI_TYPE.hmCloudStream
        // this.options.userToken = userToken
        this.options.peerId = peerId
        this.options.camId = camId
        this.options.playTime = playTime
        this.options.videoList = videoList

        this.start()
    }

    async requestEncWSSKey() {

        this.options.streamBusiType = STREAM_BUSI_TYPE.hmEncWSSStream

        return new Promise((resolve) => {

            this.start((encWssKey) => {
                resolve(encWssKey)
            })

        })
    }

    startHMEncWSSStream(playUrl) { 

        if (this.options.streamBusiType != STREAM_BUSI_TYPE.hmEncWSSStream) {

            logger.warn(this.tag, `startHMEncWSSStream fail, cur streamBusiType not equal hmEncWSSStream, so return`)
            return
        }

        if (!this.mainplayer) {
            logger.warn(this.tag, `startHMEncWSSStream fail, main player not inited`)
            return
        }

        this.mainplayer.startEncWSSStream(playUrl)
    }


    start(encWssKeyCB) {

        this.mainplayer = new MainPlayer(this); 

        this.mainplayer.on('event', (evtobj) => {

            logger.debug(this.tag, `pub event: ${evtobj.event}, params: ${JSON.stringify(evtobj.params)}`)
            this.emit(evtobj.event, evtobj.params)
        })

        this.mainplayer.on('playAbnormal', (info) => {

            logger.info(this.tag, `playAbnormal reason:${info.message}, will adjust decode params & reload stream`)
            this.restart()
        })

        this.mainplayer.on('requestEncWSSKey', (encWssKey) => {

            logger.info(this.tag, `pub requestEncWSSKey params: ${encWssKey}`)
            if (encWssKeyCB) {

                encWssKeyCB(encWssKey)
            }
        })

    }


    restart() {

        this.mainplayer.destroy();

        if (this.options.renderMode == 'mse') {
            this.options.renderMode = 'canvas'
            this.options.useMSEAudioWhenMSERenderMode = false
            this.options.decoderMode = 'soft-simd'
        }

        if (this.options.renderMode == 'canvas') {

            if (this.options.decoderMode == 'wcs') {

                this.options.decoderMode = 'soft-simd'
            }

        }

        this.start()

    }

    async destroy() {

        this.off()
        await this.mainplayer?.destroy();
        destroyLogger()
        logger.info(this.tag, `avplayer destroy`)

    }

    //public interface

    unMute() {
        logger.info(this.tag, `unmute audio`)
        this.mainplayer.unMute();
    }

    mute() {

        logger.info(this.tag, `mute audio`)
        this.mainplayer.mute();
    }

    setVolume(num) {
        num = Number(num)
        logger.info(this.tag, `setVolume ${num}`)
        if(num === 0){
            this.mainplayer.mute();
        }else{
          num = (num/100).toFixed(2)
          this.mainplayer.setVolume(num);

        }
    }

    startRecord() {  
        
        //1:音视频都录，2：只录视频 3：只录音频
         logger.info(this.tag, `startRecord`)
        this.mainplayer.startRecord(1);
    }

    stopRecord() {

        logger.info(this.tag, `stopRecord`)
        this.mainplayer.stopRecord();
    }

    setFullscreen(flag) {

        logger.info(this.tag, `setFullscreen ${flag}`)
        this.mainplayer?.setFullscreen(flag)
    
    }

    isFullscreen() {

        let result = this.mainplayer?.isFullscreen() ?? false

        logger.info(this.tag, `isFullscreen ${result}`)
        return result
    }

    resizeView(x, y, width, height) {

        logger.info(this.tag, `resizeView x:${x} y:${y} width:${width} height:${height}`)

        this.options.x = x;
        this.options.y = y;
        this.options.width = width;
        this.options.height = height;

        this.mainplayer.resizeView()
    }

    updateRenderOptions(renderOptions) {

        logger.info(this.tag, `updateRenderOptions ${JSON.stringify(renderOptions)}`)

        Object.assign(this.options.renderOptions, this.options.renderOptions, renderOptions);

        logger.info(this.tag, `updateRenderOptions succ, all options ${JSON.stringify(this.options.renderOptions)}`)
        this.mainplayer.updateRenderOptions()

    }

    startTalk(talkUrl, talkSessionId, talkResourceId, talkEncType, talkEncKey, talkEncLoad) {

        this.mainplayer.startTalk({talkBusiType:TALK_BUSI_TYPE.normalTalk, talkUrl, talkSessionId, talkResourceId, talkEncType, talkEncKey, talkEncLoad})
    }

    startDXTalk(talkUrl, talkToken, talkSessionId, talkLevel) {

        this.mainplayer.startTalk({talkBusiType:TALK_BUSI_TYPE.dxTalk, talkUrl, talkToken, talkSessionId, talkLevel})
    }

    seekHMTFCardStream(playTime) {

        this.mainplayer.seekTFCardStream(playTime)
        
    }

    playScaleStream(playSpeed) {

        this.mainplayer.playScaleStream(playSpeed)
    }

    pauseStream() {
        this.mainplayer.pauseStream()
    }

    resumeStream() {
        this.mainplayer.resumeStream()
    }

    seekHMCloudStream(playTime) {

        this.mainplayer.seekCloudStream(playTime)
    }

    stopTalk() {

        this.mainplayer.stopTalk()
    }


    downloadLog() {


        logger.info(this.tag, `downloadLog`)

        let logs = logger.getLogsCache()

        // 将数据保存到本地
        const blob = new Blob(logs, { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'text.txt';
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            URL.revokeObjectURL(url)
        }, 500);

    }



}

window.HMWebPlayer = HMWebPlayer;

export default HMWebPlayer;